<template>
    <div class="station-side">
        <div class="frame-side-bg">
            <div class="frame-side-bg__wrapper">
                <div class="frame-side-bg__top"/>
                <div class="frame-side-bg__mid"/>
                <div class="frame-side-bg__bottom"/>
            </div>
            <div class="frame-side-bg__content">
                <div class="menu-title">站点列表</div>
                <div class="menu-list">
                    <div class="menu-list-item" :class="currentNode === item.value ? 'active' : ''" :key="index"
                         v-for="(item,index) in list" @click="handleClick(item)">{{ item.label }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {listPointDevice} from "@/api/monitor";

export default {
    name: "stationTree",
    props: {
        // list: {
        //     type: Array,
        //     default: () => []
        // }
    },
    data() {
        return {
            currentNode: -1,
            list: [],
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            listPointDevice({
                page_size: 9999,
                page_index: 1,
            }).then(res => {
                // console.log('站点设备列表:', res);
                if (res.code === 0) {
                    this.list = res.data.data_info.map(item => ({
                        ...item,
                        label: item.name,
                        value: item.id,
                        api: `${item.ip || ''}${item.port ? ':' + item.port : ''}`,
                    }));
                    if(this.list && this.list.length > 0){
                        this.currentNode = this.list[0].value;
                        this.$emit('node-click', this.list[0]);
                    }
                }
            });
        },
        handleClick(item) {
            this.currentNode = item.value;
            this.$emit('node-click', item);
        }
    }
}
</script>

<style scoped lang="less">
.frame-side-bg {
    position: relative;
    width: 360px;
    height: 100%;

    &__wrapper {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
    }

    &__content {
        position: relative;
        z-index: 10;
        height: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;

        &--padding {
            padding: 20px 10px 10px 10px;
        }

        .menu-title {
            font-size: 16px;
            color: #c3ebff;
            padding: 5px 20px 10px 20px;
            border-bottom: 1px solid #225cc0;
        }

        .menu-tree {
            flex: 1;
            overflow: auto;
            padding: 0px 20px;
        }
    }

    &__top {
        height: 36px;
        background-image: url('../../../assets/images/side-bg-top.png');
    }

    &__mid {
        height: calc(100% - 75px);
        background-image: url('../../../assets/images/side-bg-mid.png');
    }

    &__bottom {
        height: 39px;
        background-image: url('../../../assets/images/side-bg-bottom.png');
    }
}

.menu-list {
    overflow-y: auto;
    flex: 1;
    margin-top: 6px;
}

.menu-list-item {
    cursor: pointer;
    margin: 8px 12px;
    padding: 0 4px;
    font-size: 14px;
    color: #ffffff;

    &:hover {
        background: #225cc0;
        padding: 0 4px;
        border-radius: 3px;
        color: #fff;
        width: fit-content;
    }

}

.active {
    background: #1b4ea8;
    padding: 0 4px;
    border-radius: 3px;
    color: #fff;
    width: fit-content;
}

</style>
